export const TRACKING_SEARCH_URL = 'marriott.com';

export const DEFAULT_TRACKING_VALUES = {
  GLOBAL_NAV: 'Global Nav',
  LABEL_NULLISH: 'Label unknown',
};

export const CACHE_MARRIOTT_URL = 'https://cache.marriott.com';

export const HOTEL_LOGO_ALT_TEXT = 'hotel logo';
export const SHOW_BROWSER_REGISTRATION = 'show_browser_registration';
